module.exports = __webpack_public_path__ + "static/main-343b5e1ed27de3950a08ef60c3ae8424.jpg";